import { Container, Col, Row, Spinner, Button } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import {
  getJournalingData,
  createJournalEntry,
  getUserJournalsByID
} from '../../../common/api/Practices'
import { ROUTE_ACTIVITIES_JOURNALING_ALL } from '../../../common/helpers/Paths'

import {
  EVENT_CATEGORY_JOURNALING,
  EVENT_ACTION_PAGEVIEW,
  saveUserEvent
} from '../../../common/api/UserEvents'
import Loading from '../../../../templates/Loading'
import './JournalFullScreen.scss'
import WebShare from 'components/web-share'
import Bookmark from 'components/bookmark/Bookmark'
import { KEY_PRACTICE_JOURNALING_WP } from 'components/common/api'

export default function JournalFullScreen({
  setHeaderTitle,
  setReturnPath,
  setShowToast,
  setToastMessage
}) {
  const { journalingId } = useParams()
  const [prompts, setPrompts] = useState([])
  const [activeIndex, setActiveIndex] = useState()
  const [previousIndex, setPreviousIndex] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [isButtonLoading, setIsButtonLoading] = useState(false)
  const [journalContent, setJournalContent] = useState('')
  const [journaPromptIds, setJournaPromptIds] = useState([])
  const [journalPastEntriesId, setJournalPastEntriesId] = useState()

  // Helper function to update current and previous index
  const updateIndex = next => {
    setActiveIndex(next)
    setPreviousIndex(activeIndex)

    // Save for later
    localStorage.setItem('activeJournalIndex' + journalingId, next)
  }

  // Helper function to get the proper class, depending on the affirmation state
  const getClassName = index => {
    let name = 'journal'

    if (index === activeIndex) name += ' active'
    else if (index === previousIndex) name += ' previous'

    return name
  }

  const handleClick = async () => {
    setIsButtonLoading(true)
    const body = {
      journal_id: journaPromptIds[activeIndex],
      journal_text: journalContent,
      journal_emoji: '',
      previousId: journalPastEntriesId
    }

    const response = await createJournalEntry(body)
    //if response is error object, show error message
    const message = response.error
      ? 'An error occurred. Please wait a moment and try again.'
      : 'Journal entry saved'
    setToastMessage(message)
    setShowToast(true)
    setIsButtonLoading(false)
  }

  const showNext = () => {
    let next = activeIndex + 1

    // Out of bounds, reset
    if (next >= prompts.length) next = 0

    updateIndex(next)
  }

  const showPrevious = () => {
    let previous = activeIndex - 1

    // Out of bounds, go to end
    if (previous < 0) previous = prompts.length - 1

    updateIndex(previous)
  }

  const handleTextAreaChange = e => {
    setJournalContent(e.target.value)
  }

  useEffect(() => {
    setHeaderTitle('Journal')
    setReturnPath(ROUTE_ACTIVITIES_JOURNALING_ALL)

    async function getJournalDataAsync() {
      const result = (await getJournalingData(journalingId)) || []

      const reformattedArray = result.map(obj => obj.post_title) || []
      const journalPromptsIds = result.map(obj => obj.ID) || []

      const active =
        Number(localStorage.getItem('activeAJournalIndex' + journalingId)) || 0

      setPrompts(reformattedArray)
      setJournaPromptIds(journalPromptsIds)
      setIsLoading(false)
      setActiveIndex(active)

      // Log access
      saveUserEvent(
        EVENT_CATEGORY_JOURNALING,
        EVENT_ACTION_PAGEVIEW,
        journalingId
      )
    }

    getJournalDataAsync()
  }, [journalingId, setHeaderTitle, setReturnPath])

  useEffect(() => {
    ;(async function getUserJournalsByIDAsync() {
      //return early
      if (activeIndex === undefined) return

      setIsLoading(true)
      const result = await getUserJournalsByID(journaPromptIds[activeIndex])
      // if there is no length, then there is no journal entry
      if (!result.length) {
        setJournalContent('')
        setJournalPastEntriesId(null)
        setIsLoading(false)
        return
      }

      // sort by id desc
      const latestdateResult = result.sort((a, b) => b.id - a.id)[0]
      setJournalContent(latestdateResult.journal_text)
      setJournalPastEntriesId(latestdateResult.id)
      setIsLoading(false)
    })()
  }, [activeIndex, journaPromptIds])

  return (
    <Loading isLoaded={isLoading}>
      <Container className='journaling-fullscreen-container'>
        <Bookmark
          category={KEY_PRACTICE_JOURNALING_WP}
          categoryObjectId={journalingId}
          color='text-black'
        />
        <WebShare
          text={prompts[activeIndex]}
          size='fs-5'
          color='text-black'
          buttonClass={'position-absolute'}
        />
        <nav className='journal-full-navigation'>
          <Row>
            <Col>
              <span className='nav-item' onClick={() => showPrevious()}>
                <i className='bi bi-arrow-left'></i>
                Back
              </span>
            </Col>
            <Col className='text-right'>
              <span className='nav-item' onClick={() => showNext()}>
                Next Prompt
                <i className='bi bi-arrow-right'></i>
              </span>
            </Col>
          </Row>
        </nav>
        {prompts.length > 1 && (
          <>
            {prompts.map((content, index) => (
              <div className={getClassName(index)} key={index}>
                <div className='journal-prompt'>{content}</div>
                <textarea
                  className='journal-entry'
                  placeholder='Write in your Remble journal and save all your thoughts and ideas in one place'
                  onChange={handleTextAreaChange}
                  value={journalContent}
                ></textarea>
                <Button
                  size='lg'
                  variant='primary'
                  className='w-100 mt-3 save-journal-button'
                  onClick={handleClick}
                  disabled={journalContent.length === 0 || isButtonLoading}
                >
                  {isButtonLoading ? (
                    <>
                      <Spinner
                        as='span'
                        animation='border'
                        size='sm'
                        role='status'
                        aria-hidden='true'
                      />
                      <span className='px-2'>Saving...</span>
                    </>
                  ) : (
                    <span>Save</span>
                  )}
                </Button>
              </div>
            ))}
          </>
        )}
      </Container>
    </Loading>
  )
}
